export default "__VITE_ASSET__ueOQy9ts__"